import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";
import { toastService } from "../../utils/toastify";
import axios from "axios";
import { getToken } from "../../utils/getToken";

export const getFeed = createAsyncThunk(
  "get/feed",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("postList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error.response.data);
    }
  }
);

export const deleteFeed = createAsyncThunk(
  "delete/feed",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch("postStatusChanged", payload);
      if (response?.data?.code === 200) {
        toastService.success("post deleted successfully");
        return response.data;
      } else {
        toastService.error(response?.data?.message);
        return rejectWithValue(response?.data);
      }
    } catch (error) {
      console.log(error);
      toastService.error("post delete failed");
      rejectWithValue(error.response.data);
    }
  }
);
export const pinnedFeed = createAsyncThunk(
  "pinned/feed",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch("postPinned", payload);
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error.response.data);
    }
  }
);
export const getCommentList = createAsyncThunk(
  "get/commentList",
  async ({ postId, payload }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `commentOfPost?postId=${postId}`,
        payload
      );
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error.response.data);
    }
  }
);
export const createPost = createAsyncThunk(
  "createPost/feed",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`createPost`, payload);
      if (response?.data?.code === 200) {
        toastService.success("post created successfully");
        return response.data;
      } else {
        toastService.error(response?.data?.message);
        return rejectWithValue(response?.data);
      }
    } catch (error) {
      console.log(error);
      toastService.error(error.response.data || "error");
      rejectWithValue(error.response.data);
    }
  }
);
export const getPost = createAsyncThunk(
  "get/Post",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("postView", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error.response.data);
    }
  }
);
export const feedImageUpload = createAsyncThunk(
  "uploadFile/feed",
  async (payload, { rejectWithValue }) => {
    console.log({ payload });
    const token = getToken("adminLogin");
    try {
      const response = await axios.post(
        "https://prospuh2learn.com/api/v1/admin/uploadDocument",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log({ response });

      if (response?.data?.code === 200) {
        toastService.success("File Upload  successfully");
        return response?.data;
      } else {
        toastService.error(response?.data?.message);
        return rejectWithValue(response?.data);
      }
    } catch (error) {
      console.log("Error:", error);
      const errorMessage =
        error?.response?.data?.message || "Something went wrong!";
      toastService.error(errorMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const feedSlice = createSlice({
  name: "feed",
  initialState: {
    feeds: [],
    commentList: [],
    postViewData: [],
    loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getFeed.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFeed.fulfilled, (state, action) => {
      state.loading = false;
      state.feeds = action.payload;
    });
    builder.addCase(getFeed.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
    builder.addCase(getCommentList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCommentList.fulfilled, (state, action) => {
      state.loading = false;
      state.commentList = action.payload;
    });
    builder.addCase(getCommentList.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
    builder.addCase(getPost.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPost.fulfilled, (state, action) => {
      state.loading = false;
      state.postViewData = action.payload;
    });
    builder.addCase(getPost.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
  },
});

export default feedSlice.reducer;
